import { render, staticRenderFns } from "./ObjectsList.vue?vue&type=template&id=71737660&scoped=true&lang=pug"
import script from "./ObjectsList.vue?vue&type=script&lang=js"
export * from "./ObjectsList.vue?vue&type=script&lang=js"
import style0 from "./ObjectsList.vue?vue&type=style&index=0&id=71737660&prod&lang=stylus"
import style1 from "./ObjectsList.vue?vue&type=style&index=1&id=71737660&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71737660",
  null
  
)

export default component.exports